import { useUser } from '@clerk/clerk-react';

export type Role = 'editor' | 'viewer';

export function useRole() {
  const { user, isLoaded } = useUser();

  const role = user?.publicMetadata?.role as Role | undefined;

  const isEditor = role === 'editor';
  const isViewer = role === 'viewer' || !role; // Default to viewer if no role set

  return {
    role,
    isEditor,
    isViewer,
    isLoaded,
  };
}
